module.exports = __webpack_public_path__ + "img/checkm8.058512d4.jpg";